import React from 'react'
import styled from 'styled-components'

import {
  CREDIT_NOTIFICATION_TYPES,
  CREDIT_NOTIFICATIONS_COPY,
} from 'containers/Agents/creditConstants'

// Exact Figma asset for node 4584:147988 — wired-flat-298-coins#in-reveal
// (the reveal-in coin animation; distinct from the wallet illustration's coin.gif).
import coinGif from './assets/coins-in-reveal.gif'

// Figma 4584:147988 — "AI Credits are available!" toast (PLG Experience Flow 5 /
// Purchase Flow §3.6). White card, 2px blue border, blue-tinted shadow, animated
// coins (wired-flat-298-coins#in-reveal), blue SemiBold title, gray body, X close.
const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 360px;
  padding: 16px;
  background: var(--color-elevated, #ffffff);
  border: 2px solid var(--colors-blue-500, #3063fd);
  border-radius: 14px;
  box-shadow:
    0px 4px 3px rgba(234, 239, 255, 1),
    0px 2px 2px rgba(234, 239, 255, 1);
  font-family: Poppins, sans-serif;
`

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const CoinIcon = styled.img`
  width: 35px;
  height: 35px;
  object-fit: contain;
  pointer-events: none;
`

const Title = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--colors-blue-900, #132198);
  white-space: nowrap;
`

const Body = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--t-colors-gray-950, #313036);
`

const CloseButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  width: 12px;
  height: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--colors-blue-500, #3063fd);
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
    border-radius: 2px;
  }
`

const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3L9 9M9 3L3 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)

/** Figma 4584:147988 — restored-credits success toast (all tenant users). */
const CreditsRestoredToast = ({ onClose, id = 'credits-restored-toast' }) => {
  const copy = CREDIT_NOTIFICATIONS_COPY[CREDIT_NOTIFICATION_TYPES.CREDITS_RESTORED]

  return (
    <Card id={id} role="status" aria-live="polite">
      <TopRow>
        <TitleGroup>
          <CoinIcon src={coinGif} alt="" />
          <Title>{copy.title}</Title>
        </TitleGroup>
        <CloseButton type="button" aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </TopRow>
      <Body>{copy.subtext()}</Body>
    </Card>
  )
}

export default CreditsRestoredToast
